import React from "react";
import { ProductShowcase, ProductShowcaseImage } from "ui/product-showcase";
import audienceBuilderImage from "../../../public/assets/product-screens/audience-builder.png";
import audienceBuilderMobileImage from "../../../public/assets/product-screens/audience-builder-mobile.png";
import journeysImage from "../../../public/assets/product-screens/journeys-screen.png";
import journeysMobileImage from "../../../public/assets/product-screens/journeys-mobile.png";
import realTimeImage from "../../../public/assets/product-screens/real-time.png";
import realTimeMobileImage from "../../../public/assets/product-screens/real-time-mobile.png";
import insightsImage from "../../../public/assets/product-screens/insights.png";
import insightsMobileImage from "../../../public/assets/product-screens/insights-mobile.png";
import audienceBuilderTravel from "../../../public/assets/product-screens/audience-builder-travel.png";
import audienceBuilderTravelMobile from "../../../public/assets/product-screens/audience-builder-travel-mobile.png";

const audienceTravelAlt =
  "Hightouch Audience builder named 'USA Active Customers' with filters selecting users with their country equal to 'USA' and had booked a trip greater than $100 within 7 days.";
const audiencesAlt =
  "Hightouch Audience builder named 'USA Active Customers' with filters selecting users with their country equal to 'USA' and had viewed a product greater than $50 within 7 days.";
const journeysAlt =
  "Hightouch Journey named 'Revival campaign', running a live campaign that sends an email notification to audiences with churn risk.";
const realTimeAlt =
  "UI screenshot of an audience named 'Hotel booking points upsell' with the realtime toggle enabled. The audience filter shows 'Performed Flight search at least 1 time within 15 minutes ago.', and 'Booked a flight at least 1 time within 36 months ago where status equals completed.'";
const insightsAlt =
  "Hightouch Intelligence displaying a graph regarding how much revenue a user earned from campaigns within the last year.";

/**
 * For now, these are using static images on web screens.
 * Ideally, we will update animations in `components/animations/product-screens`.
 */
const audiencesProductShowcase = (
  <ProductShowcase
    isPriority
    variant="sunset"
    productScreen={<ProductShowcaseImage isPriority src={audienceBuilderImage} alt={audiencesAlt} />}
    mobileProductScreen={<ProductShowcaseImage isMobile src={audienceBuilderMobileImage} alt={audiencesAlt} />}
  />
);

const audiencesTravelProductShowcase = (
  <ProductShowcase
    isPriority
    variant="coastal"
    productScreen={<ProductShowcaseImage isPriority src={audienceBuilderTravel} alt={audienceTravelAlt} />}
    mobileProductScreen={<ProductShowcaseImage isMobile src={audienceBuilderTravelMobile} alt={audienceTravelAlt} />}
  />
);

const journeysProductShowcase = (
  <ProductShowcase
    isPriority
    variant="dusk"
    productScreen={<ProductShowcaseImage isPriority src={journeysImage} alt={journeysAlt} />}
    mobileProductScreen={<ProductShowcaseImage isMobile src={journeysMobileImage} alt={journeysAlt} />}
  />
);

const realTimeProductShowcase = (
  <ProductShowcase
    isPriority
    variant="desert"
    productScreen={<ProductShowcaseImage isPriority src={realTimeImage} alt={realTimeAlt} />}
    mobileProductScreen={<ProductShowcaseImage isMobile src={realTimeMobileImage} alt={realTimeAlt} />}
  />
);

const intelligenceProductShowcase = (
  <ProductShowcase
    isPriority
    variant="poppy"
    productScreen={<ProductShowcaseImage isPriority src={insightsImage} alt={insightsAlt} />}
    mobileProductScreen={<ProductShowcaseImage isMobile src={insightsMobileImage} alt={insightsAlt} />}
  />
);

export {
  audiencesProductShowcase,
  audiencesTravelProductShowcase,
  realTimeProductShowcase,
  journeysProductShowcase,
  intelligenceProductShowcase,
};
